import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { SettingService } from './setting.service';
import { ToastService } from '../../@theme/service/toast.service';
import { NbDialogRef } from '@nebular/theme';
import { environment } from '../../../environments/environment';
import { Accounts } from '../../common/util/accounts';

@Component({
  selector: 'ngx-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SettingComponent implements OnInit {
  public products: any = [];
  public medias: any = [];
  public saveBtn = false;

  constructor(
    private settingService: SettingService,
    private toastService: ToastService,
    public dialogRef: NbDialogRef<any>,
  ) {}

  ngOnInit() {
    const arr = [this.currentPolicy()];
    // Promise.all(arr)
    //   .then(() => {
    //     this.selectedObj(
    //       this.policy.productUsagePolicy.productIds,
    //       this.products,
    //     );

    //     this.selectedObj(this.policy.mediaPolicy.ignoreDevices, this.medias);
    //   })
    //   .catch((e: any) => {
    //     console.error(e);
    //     this.reset();
    //   });
  }

  selectedObj(select: any, all: any): any {
    select.forEach((element: any) =>
      all.splice(all.indexOf(all.find((d: any) => d.id === element.id)), 1),
    );
  }

  /**
   * 정책설정 불러오기
   */
  currentPolicy(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.settingService.getCurrentPolicy().subscribe((d: any) => {
      });
    });
  }

  /**
   * 저장
   */
  save() {
    this.saveBtn = true;

  }

  /**
   * 초기화
   */
  reset() {
  }

  /**
   * 더블클릭시 프로젝트 추가
   * @param allObj 전체 obj
   * @param selectObj 선택된 obj
   * @param i index
   * @param applyObj 적용 obj
   */
  addObj(allObj: any, selectObj: any, i: number, applyObj: any): void {
    allObj.splice(i, 1);
    applyObj.push(selectObj);
  }

  /**
   * 더블클릭시 프로젝트 삭제
   * @param obj
   * @param i
   * @param type
   */
  removeObj(allObj: any, selectObj: any, i: number, applyObj: any): void {
    applyObj.splice(i, 1);
    allObj.push(selectObj);
  }

  onClickEvent(obj: any): void {
    this.dialogRef.close(obj);
  }
}
